import type { ElementRef } from '../../../lib/teact/teact';

export function resolveSharedAnimationProps(
  sharedCanvasRef?: ElementRef<HTMLCanvasElement>,
  sharedCanvasHqRef?: ElementRef<HTMLCanvasElement>,
) {
  const withSharedAnimation = Boolean(sharedCanvasRef?.current || sharedCanvasHqRef?.current);

  return {
    withSharedAnimation,
    sharedCanvasRef: withSharedAnimation ? sharedCanvasRef : undefined,
    sharedCanvasHqRef: withSharedAnimation ? sharedCanvasHqRef : undefined,
  };
}
